export const CT_ACCESS_TOKEN = 'CT_ACCESS_TOKEN'
export const CT_VERSION = VERSION // eslint-disable-line
export const CT_COMMENT = 'CT_COMMENT'
